module.exports = __webpack_public_path__ + "static/img/pay_succ_vava.a33a6aac.webp";